var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "page-dialog",
      attrs: {
        "append-to-body": "",
        title: "修改登录密码",
        visible: _vm.visible,
        width: "480px",
        "close-on-click-modal": false,
      },
      on: {
        closed: _vm.handleClosed,
        close: function ($event) {
          return _vm.$emit("update:visible", false)
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "formRef",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "label-width": "80px",
            "label-position": "right",
            size: "small",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "会员账号", prop: "account" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入会员账号", disabled: "" },
                model: {
                  value: _vm.form.account,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "account", $$v)
                  },
                  expression: "form.account",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "新密码", prop: "password" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入新密码" },
                model: {
                  value: _vm.form.password,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "password", $$v)
                  },
                  expression: "form.password",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.handleCancel } }, [
            _vm._v("取消"),
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleConfirm } },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }